import { createFileRoute } from '@tanstack/react-router';

import { NotFoundContent } from './404';

import { DEFAULT_LOCALE } from '~/utils/i18n';

/**
 * Catch-all route that handles any unmatched paths
 * This ensures SSR works properly for routes that don't have specific route files
 * On the client, unmatched routes will show the 404 page
 */
const CatchAllPage = () => {
  return <NotFoundContent />;
};

export const Route = createFileRoute('/$')({
  beforeLoad: ({ context }) => ({
    ...context,
    locale: DEFAULT_LOCALE,
  }),
  component: CatchAllPage,
});
